// Module
var code = "<page-header title=\"'主机浏览器'\" breadcrumbs=\"['Host', {label:$ctrl.host.Name, link:'docker.host'},  'browse']\"> </page-header>\n\n<host-browser ng-if=\"$ctrl.host\" endpoint-id=\"$ctrl.endpoint.Id\"></host-browser>\n";
// Exports
var _module_exports = code;;
var path = 'app/docker/views/host/host-browser-view/host-browser-view.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;